import { render } from "./PreSongCard.vue?vue&type=template&id=40c4e003&scoped=true"
import script from "./PreSongCard.vue?vue&type=script&lang=ts"
export * from "./PreSongCard.vue?vue&type=script&lang=ts"

import "./PreSongCard.vue?vue&type=style&index=0&id=40c4e003&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40c4e003"

export default script